"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var formik_1 = require("formik");
var moment_1 = __importDefault(require("moment"));
var FormItem_1 = require("../FormItem");
var contexts_1 = require("../../contexts");
var FormDatePicker = function (props) {
    var name = props.name, valueFormat = props.valueFormat, restProps = __rest(props, ["name", "valueFormat"]);
    var allowEdit = react_1.useContext(contexts_1.PermissionContext).allowEdit;
    return (react_1.default.createElement(formik_1.Field, { name: name }, function (_a) {
        var value = _a.field.value, _b = _a.form, setFieldValue = _b.setFieldValue, setFieldTouched = _b.setFieldTouched;
        return (react_1.default.createElement(antd_1.DatePicker, __assign({ style: { width: '100%' }, disabled: !allowEdit, value: value ? moment_1.default(value, valueFormat) : undefined, onChange: function (date) {
                if (date) {
                    var formattedDate = valueFormat ? date.format(valueFormat) : date.toISOString();
                    setFieldValue(name, formattedDate);
                    setFieldTouched(name, true);
                }
                else {
                    setFieldValue(name, date);
                }
            } }, restProps)));
    }));
};
exports.default = FormItem_1.withFormItem(FormDatePicker);
